<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="args['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="args['order.no']" placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="args['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="args['item.name']" placeholder="placeholder.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="args['item.barcodes']" placeholder="placeholder.itemBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="args['lot.no']" placeholder="placeholder.lotNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="args.range" clearable linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" sortable title="business.label.orderNo" width="130"/>
        <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="150"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="dosageForm.name" title="business.label.dosageForm" width="120"/>
        <vxe-column field="item.permitHolder" title="business.label.permitHolder" width="140"/>
        <vxe-column field="lot.no" sortable title="business.label.lotNo" width="100"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
        <vxe-column field="lot.producingArea" title="business.label.producingArea" width="150"/>
        <vxe-column field="submissionAdvice.operator" title="business.label.submissionAdviceOperator" width="80"/>
        <vxe-column field="submissionAdvice.content" title="business.label.submissionAdviceContent" width="150"/>
        <vxe-column field="approvalAdvice.operator" title="business.label.approvalAdviceOperator" width="80"/>
        <vxe-column field="approvalAdvice.content" title="business.label.approvalAdviceContent" width="150"/>
        <vxe-column field="reportAdvice.operator" title="business.label.reportAdviceOperator" width="80"/>
        <vxe-column field="reportAdvice.content" title="business.label.reportAdviceContent" width="150"/>
        <vxe-column field="destructionAdvice.operator" title="business.label.destructionAdviceOperator" width="80"/>
        <vxe-column field="destructionAdvice.content" title="business.label.destructionAdviceContent" width="150"/>
        <vxe-column field="detail.quantity" title="business.label.quantity" width="80"/>
        <vxe-column field="detail.reasons" title="business.label.reason" width="120"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment'
import { getOptions } from '@/utils/util'

export default {
  name: 'DisqualificationQuery',
  data() {
    return {
      loading: false,
      data: [],
      owners: [],
      page: 1,
      size: 20,
      contentSize: 0,
      args: {
        'order.no': '',
        'owner.id': null,
        'item.no': '',
        'item.name': '',
        'item.barcodes': '',
        'lot.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.args)
      if (args.range.length > 0) {
        args['dateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateFilter'] = null
      }
      findAll('disqualificationDetailFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.args = {
        'order.no': '',
        'owner.id': undefined,
        'item.no': '',
        'item.name': '',
        'item.barcodes': '',
        'lot.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    }
  }
}
</script>